import { useStoreMap } from 'effector-react';
import { TemplateId } from '@types';
import useEditingStore from '@hooks/useEditingStore';
import { $sceneMap, $tourData } from '@stores/dataStores';
import {
  $GateSearchBtn,
  $editingCategoryConfig,
  $editingFlag,
  $editingUIColor,
} from '@stores/editingStores';
import { getTemplateConfig } from '@utils/templateConfig';
import { TProjectIcon } from '../TProjectIcon';

export function TProjectButtons() {
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const showSearch = useEditingStore({
    $data: $tourData,
    dataFn: (state) => !!state.config?.search?.enabled,
    $editing: $GateSearchBtn.state,
  });
  const showRemark = !!(flag?.showTourRemark ?? 1);
  const showShare = !!(flag?.showShareBtn ?? 1);
  const showLike = !!(flag?.showLikeBtn ?? 1);
  const showCommentBtn = !!(flag?.showCommentBtnV2 ?? 1);
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) =>
      state.config?.ui ??
      getTemplateConfig(TemplateId.project)('uiColor') ??
      {},
    $editing: $editingUIColor.store,
  });
  const categoryConfig = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.categoryConfig,
    $editing: $editingCategoryConfig.store,
  });
  const showCategoryButton = !!categoryConfig?.enabledButton;

  const showNextBtns = useStoreMap({
    store: $sceneMap,
    keys: [],
    fn: (state) => state.size > 1,
  });

  return (
    <>
      {showCategoryButton && (
        <div
          className="absolute left-15 bottom-15 flex h-50 items-center gap-16 rounded bg-white px-15"
          style={{
            backgroundColor: `rgba(${ui.panelBgColor})`,
          }}
        >
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixR8IF8OtOCKNUcwCAfp8kda">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixR8IF8OtOCKNUcwCAfp8kda)">
                  <path
                    fill={color}
                    d="M3 4h18v2H3V4Zm0 7h18v2H3v-2Zm0 7h18v2H3v-2Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        </div>
      )}
      <div
        className="absolute bottom-15 flex h-50 items-center gap-16 rounded bg-white px-15"
        style={{
          backgroundColor: `rgba(${ui.panelBgColor})`,
        }}
      >
        {showNextBtns && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixyoUp7dqf7wTgRRbK5LPSGa">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixyoUp7dqf7wTgRRbK5LPSGa)">
                  <path
                    fill={color}
                    d="m13.914 12 4.793-4.793-1.414-1.414L11.086 12l6.207 6.207 1.414-1.414L13.914 12ZM7 18V6h2v12H7Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
        <TProjectIcon>
          {({ color }) => (
            <>
              <defs>
                <clipPath id="prefixhN7pIhXupaA8Ko6u3zjOga">
                  <rect width="24" height="24" rx="0" />
                </clipPath>
              </defs>
              <g clipPath="url(#prefixhN7pIhXupaA8Ko6u3zjOga)">
                <path
                  fill={color}
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM10.622 8.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332Z"
                />
              </g>
            </>
          )}
        </TProjectIcon>
        {showNextBtns && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixJlvEjvcQjrWr8k56-45G7a">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixJlvEjvcQjrWr8k56-45G7a)">
                  <path
                    fill={color}
                    d="m10.086 12-4.793 4.793 1.414 1.414L12.914 12 6.707 5.793 5.293 7.207 10.086 12ZM17 6v12h-2V6h2Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
        {(showRemark || showSearch) && (
          <div className="h-24 w-1 bg-[#7c7c7c]/20" />
        )}
        {showRemark && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixrj_6Wbpn1KZfzXk4272v_a">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixrj_6Wbpn1KZfzXk4272v_a)">
                  <path
                    fill={color}
                    d="M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8Zm-2 1h-5V4H5v16h14V9ZM8 7h3v2H8V7Zm0 4h8v2H8v-2Zm0 4h8v2H8v-2Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
        {showSearch && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefix8EafzeyFcQ5lPn85scQyOa">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefix8EafzeyFcQ5lPn85scQyOa)">
                  <path
                    fill={color}
                    d="M10.861 2c4.891 0 8.861 3.97 8.861 8.861s-3.97 8.861-8.861 8.861S2 15.752 2 10.861 5.97 2 10.861 2Zm0 15.753a6.89 6.89 0 0 0 6.892-6.892 6.89 6.89 0 0 0-6.892-6.892 6.89 6.89 0 0 0-6.892 6.892 6.89 6.89 0 0 0 6.892 6.892Zm8.354.07L22 20.608 20.608 22l-2.785-2.785 1.392-1.392Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
        {(showLike || showCommentBtn || showShare) && (
          <div className="h-24 w-1 bg-[#7c7c7c]/20" />
        )}
        {showLike && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixgRcMR9Wr206URCj5Z7hRWa">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixgRcMR9Wr206URCj5Z7hRWa)">
                  <path
                    fill={color}
                    d="M12.001 4.488c2.349-2.053 5.979-1.985 8.242.223a5.731 5.731 0 0 1 .236 8.02L11.999 21l-8.478-8.27a5.732 5.732 0 0 1 .236-8.019c2.265-2.205 5.888-2.279 8.244-.223Zm6.826 1.599c-1.5-1.463-3.92-1.522-5.49-.15l-1.335 1.168-1.336-1.166c-1.575-1.375-3.99-1.315-5.494.15a3.821 3.821 0 0 0-.192 5.308L12 18.244l7.02-6.847a3.82 3.82 0 0 0-.193-5.31Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
        {showCommentBtn && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixOfcfHqW7miabuj01ZI-W6a">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixOfcfHqW7miabuj01ZI-W6a)">
                  <path
                    fill={color}
                    d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm-.692-2H20V5H4v13.385L5.763 17ZM11 10h2v2h-2v-2Zm-4 0h2v2H7v-2Zm8 0h2v2h-2v-2Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
        {showShare && (
          <TProjectIcon>
            {({ color }) => (
              <>
                <defs>
                  <clipPath id="prefixG3glNJQF666tj49fG5hAba">
                    <rect width="24" height="24" rx="0" />
                  </clipPath>
                </defs>
                <g clipPath="url(#prefixG3glNJQF666tj49fG5hAba)">
                  <path
                    fill={color}
                    d="m13.12 17.023-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755ZM6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                  />
                </g>
              </>
            )}
          </TProjectIcon>
        )}
      </div>
    </>
  );
}
